import { render, staticRenderFns } from "./file-opener.vue?vue&type=template&id=1566ddea&scoped=true&"
import script from "./file-opener.vue?vue&type=script&lang=ts&"
export * from "./file-opener.vue?vue&type=script&lang=ts&"
import style0 from "./file-opener.vue?vue&type=style&index=0&id=1566ddea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1566ddea",
  null
  
)

export default component.exports